import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

// Connects to data-controller="modal-alert"
// Displays a flash message in a SweetAlert2 modal on page load.
export default class extends Controller {
  static values = { message: String }

  connect() {
    if (this.messageValue) {
      Swal.fire({ html: this.messageValue });
    }
  }
}
